import React from 'react';
import { IonText } from '@ionic/react';
import LeadCard from './LeadCard';

interface IProps {
    leads: any[];
}

const Leads: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.leads) && props.leads.map((lead, index) => <LeadCard lead={lead} key={index} />)}
        </>
    );
};

export default Leads;
